// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"8036e3c3","167":"5e322f68","363":"574ae4ee","469":"831a93b8","505":"8397f217","652":"5e322f68","684":"831a93b8","867":"541db105","935":"5f5681b3"}[chunkId] + ".chunk.css";
};